import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import { useLogs } from "../context/LogContext";

const Login = () => {
  const [email, setEmail] = useState("");
  const name = "Hariom";
  const deviceKeyHash =
    "55094c6e3603336f06db039912ee50fe137d7e6d34db47cc7bcac61c11796278";
  const fcmToken = "qwerfdsasdf";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { addLog } = useLogs();
  const navigate = useNavigate();

  const handleLogin = async () => {
    addLog(`Login button clicked`);
    addLog(`API Request Body: { email: "${email}", password: "${password}" }`);
    try {
      // const res = await loginApi(email, password);
      // addLog(`API Response: ${JSON.stringify(res)}`);
      const response = await api.post(`/users/login`, {
        name,
        deviceKeyHash,
        fcmToken,
      });
      // addLog(`API Response: ${JSON.stringify(response)}`);
      localStorage.setItem("userData", JSON.stringify(response.data.data));
      navigate("/profile");

      // localStorage.setItem("user", JSON.stringify(res.user));
      // navigate("/profile");
    } catch (err) {
      addLog(`API Error: ${err.message}`);
      setError(err.message);
    }
  };

  return (
    <div className="left-content">
      <h2>Login</h2>
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
          //   addLog(`Email input: ${e.target.value}`);
        }}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
          //   addLog(`Password input: ${e.target.value}`);
        }}
      />
      <button onClick={handleLogin}>Login</button>
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default Login;
